import { render, staticRenderFns } from "./expense-details.vue?vue&type=template&id=7033ee20&"
import script from "./expense-details.vue?vue&type=script&lang=js&"
export * from "./expense-details.vue?vue&type=script&lang=js&"
import style0 from "./expense-details.vue?vue&type=style&index=0&id=7033ee20&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports